export class DrEntityAttribute {
    name: string;
    value: string;

    constructor(value?: Partial<DrEntityAttribute>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
